interface IconProps {
  size?: number;
  className?: string;
}

const base = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
});

export const AlertIcon = ({ size = 16, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <circle cx="10" cy="10" r="7.5" />
    <line x1="10" y1="6" x2="10" y2="10.5" />
    <circle cx="10" cy="13.5" r="0.6" fill="currentColor" />
  </svg>
);
export const CheckIcon = ({ size = 16, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <polyline points="4 10.5 8.5 15 16 6" />
  </svg>
);
export const ChevronLeft = ({ size = 20, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <polyline points="12.5 4 6.5 10 12.5 16" />
  </svg>
);
export const ChevronRight = ({ size = 20, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <polyline points="7.5 4 13.5 10 7.5 16" />
  </svg>
);
export const ArrowRight = ({ size = 20, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <line x1="3" y1="10" x2="16" y2="10" />
    <polyline points="11 5 16 10 11 15" />
  </svg>
);
export const ArrowLeft = ({ size = 20, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <line x1="17" y1="10" x2="4" y2="10" />
    <polyline points="9 5 4 10 9 15" />
  </svg>
);
export const LockIcon = ({ size = 16, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <rect x="4.5" y="9" width="11" height="8" rx="2" />
    <path d="M7 9V6.5a3 3 0 0 1 6 0V9" />
  </svg>
);
export const PinIcon = ({ size = 20, className }: IconProps) => (
  <svg {...base(size)} className={className}>
    <path d="M10 17s-5.5-4.6-5.5-8.5A5.5 5.5 0 0 1 15.5 8.5C15.5 12.4 10 17 10 17z" />
    <circle cx="10" cy="8.5" r="1.8" />
  </svg>
);
